import React from 'react';
import classnames from 'classnames';
import {AdminAccessOrganization} from 'src/services/AdminAccessOrganizationService';

interface Props {
  organizations: AdminAccessOrganization[];
  onDelete: (org: AdminAccessOrganization) => void;
}

const OrganizationsTable = ({organizations, onDelete}: Props) => {
  if (organizations.length === 0) return null;

  return (
    <div className="container">
      <h2>Search Results</h2>
      <table className={classnames('table', 'table-hover')}>
        <thead>
          <tr>
            <th>Name</th>
            <th>Address</th>
            <th>Phone</th>
            <th>URL</th>
            <th></th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {organizations.map((org) => (
            <tr key={org._id}>
              <td>{org.display_name || org.name}</td>
              <td>
                {org.address && (
                  <>
                    {org.address}
                    <br />
                  </>
                )}
                {org.city && org.state && org.zip && `${org.city}, ${org.state} ${org.zip}`}
              </td>
              <td>{org.phone}</td>
              <td>{org.url}</td>
              <td>
                <a href={`/admin/tools/access-organizations/${org._id}/edit`}>Edit</a>
              </td>
              <td>
                <button type="button" className="btn-link" onClick={() => onDelete(org)}>
                  Destroy
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OrganizationsTable;
